const getAuthConfig = () => {
    const audience =
        import.meta.env.VITE_AUTH0_AUDIENCE && import.meta.env.VITE_AUTH0_AUDIENCE !== "YOUR_API_IDENTIFIER"
            ? import.meta.env.VITE_AUTH0_AUDIENCE
            : null;

    return {
        clientId: import.meta.env.VITE_AUTH0_CLIENT_ID,
        domain: import.meta.env.VITE_AUTH0_DOMAIN,
        ...(audience ? { audience } : null),
        connectionScope: import.meta.env.VITE_AUTH0_CONNECTION_SCOPE,
    };
};

export default getAuthConfig;
